import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className="footer-link-content">
      <h1>PRIVACY AND POLICY</h1>

      <p>Varnamika is committed to protecting the privacy and security of your personal information. This Privacy Policy describes how we collect, use, and disclose personal information when you visit our website or make a purchase from our jewelry store.</p>

      <section>
        <h2>Information We Collect</h2>
        <p>When you visit our website or place an order, we may collect certain information from you, including:</p>
        <ul>
          <li>Personal information such as your name, email address, mailing address, and phone number.</li>
          <li>Payment information, such as credit card details or other payment methods.</li>
          <li>Order details, including the products you purchase and the shipping address.</li>
          <li>Information collected automatically through cookies and other tracking technologies, such as your IP address, browser type, and browsing preferences.</li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Information</h2>
        <p>We may use the information we collect for various purposes, including to:</p>
        <ul>
          <li>Process and fulfill your orders.</li>
          <li>Communicate with you about your orders, account, or inquiries.</li>
          <li>Send you marketing communications about our products and promotions, if you have opted in to receive such communications.</li>
          <li>Improve our website and services.</li>
          <li>Prevent and detect fraud or abuse.</li>
        </ul>
      </section>

      <section>
        <h2>Information Sharing and Disclosure</h2>
        <p>We may share your personal information with third parties in the following circumstances:</p>
        <ul>
          <li>With service providers who help us operate our business and provide services to you, such as payment processors, shipping carriers, and IT service providers.</li>
          <li>With our business partners for marketing purposes, if you have opted in to receive such communications.</li>
          <li>When required by law or to protect our rights, property, or safety, or the rights, property, or safety of others.</li>
        </ul>
      </section>

      <section>
        <h2>Data Retention</h2>
        <p>We will retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.</p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. You may also have the right to object to or restrict certain processing of your personal information. If you would like to exercise any of these rights, please contact us using the contact information provided below.</p>
      </section>

      <section>
        <h2>Changes to this Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. We encourage you to review this Privacy Policy periodically for any updates.</p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at <a href="mailto:example@gmail.com">example@gmail.com</a> or Mobile no: 9876543210.</p>
      </section>
    </div>
  )
}

export default PrivacyPolicy